import { cn } from '@/src/utils';
import Typo from '@/components/atom/Typo';
import React from 'react';
import { Link, useLocation, useSearchParams } from 'react-router-dom';

interface NavItemProps {
  isActive?: boolean;
  onClick?: () => void;
  path: string;
  label: string;
}
function NavItem({ isActive, onClick, label, path }: NavItemProps) {
  const sideNavStyle = isActive ? 'bg-primary hover:bg-primary500' : '';
  const sideNavTypoStyle = isActive ? 'text-white' : 'text-gray9';
  const [_, setSearchParams] = useSearchParams();

  const { pathname } = useLocation();

  return (
    <li
      className={cn(
        'group cursor-pointer rounded-[8px] transition-all hover:bg-gray1',
        sideNavStyle,
      )}
      onClick={() => onClick?.()}
    >
      <Link
        to={path}
        className="h-ful flex w-full py-2 pl-8 pr-4"
        onClick={e => {
          if (path === pathname) {
            e.preventDefault();
            location.href = path;
          }
        }}
      >
        <Typo className={cn(sideNavTypoStyle, 'whitespace-pre')}>{label}</Typo>
      </Link>
    </li>
  );
}

export default NavItem;
